import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import { FiPlus, FiEdit, FiTrash2, FiVideo, FiX, FiUser } from 'react-icons/fi';
import SpeakerModal from '../components/SpeakerModal';
import SpeakerDashboard from '../components/SpeakerDashboard';
import './Speakers.css';

const Speakers = () => {
  const { isModerator } = useAuth();
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingSpeaker, setEditingSpeaker] = useState(null);
  const [dashboardSpeaker, setDashboardSpeaker] = useState(null);

  useEffect(() => {
    fetchSpeakers();
  }, []);

  const fetchSpeakers = async () => {
    try {
      const response = await axios.get('/api/speakers/');
      setSpeakers(response.data.results || response.data);
    } catch (error) {
      toast.error('Ошибка загрузки спикеров');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Вы уверены, что хотите удалить этого спикера?')) {
      return;
    }

    try {
      await axios.delete(`/api/speakers/${id}/`);
      toast.success('Спикер удален');
      fetchSpeakers();
    } catch (error) {
      toast.error('Ошибка удаления спикера');
    }
  };

  const handleEdit = (speaker) => {
    setEditingSpeaker(speaker);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingSpeaker(null);
    fetchSpeakers();
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="speakers-page">
      <div className="page-header">
        <h1>Спикеры</h1>
        {isModerator && (
          <button className="btn btn-primary" onClick={() => setModalOpen(true)}>
            <FiPlus /> Добавить спикера
          </button>
        )}
      </div>

      <div className="speakers-grid">
        {speakers.length > 0 ? (
          speakers.map((speaker) => (
            <div key={speaker.id} className="speaker-card">
              <div className="speaker-avatar-ring" title={speaker.full_name}>
                <div className="speaker-avatar-inner">
                  {speaker.photo ? (
                    <img
                      src={speaker.photo}
                      alt={speaker.full_name}
                      className="speaker-photo-card"
                      loading="lazy"
                      decoding="async"
                    />
                  ) : (
                    <div className="speaker-photo-placeholder" aria-hidden>
                      <FiUser />
                    </div>
                  )}
                </div>
              </div>
              <div className="speaker-info-card">
                <h3>{speaker.full_name}</h3>
                <p>{speaker.credentials}</p>
              </div>
              <div className="speaker-actions">
                <button 
                  className="icon-btn" 
                  onClick={() => setDashboardSpeaker(speaker)}
                  title="Вебинары спикера"
                >
                  <FiVideo />
                </button>
                {isModerator && (
                  <>
                    <button className="icon-btn" onClick={() => handleEdit(speaker)}>
                      <FiEdit />
                    </button>
                    <button className="icon-btn danger" onClick={() => handleDelete(speaker.id)}>
                      <FiTrash2 />
                    </button>
                  </>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <p>Нет спикеров</p>
          </div>
        )}
      </div>

      {isModerator && (
        <SpeakerModal
          open={modalOpen}
          onClose={handleCloseModal}
          speaker={editingSpeaker}
        />
      )}

      {dashboardSpeaker && (
        <SpeakerDashboard
          speaker={dashboardSpeaker}
          onClose={() => setDashboardSpeaker(null)}
        />
      )}
    </div>
  );
};

export default Speakers;
